import { lazy } from 'react';

const CreateSchoolList = lazy(() =>
  import('./components/CreateSchoolListModal'),
);
const UpdateSchoolList = lazy(() =>
  import('./components/UpdateSchoolListModal'),
);
const DeleteSchoolList = lazy(() =>
  import('./components/DeleteSchoolListModal'),
);
const ConfirmSaveNotesModal = lazy(() =>
  import('./components/ConfirmSaveNotesModal'),
);

export default {
  CONFIRM_SAVE_NOTES: ConfirmSaveNotesModal,
  CREATE_SCHOOL_LIST: CreateSchoolList,
  DELETE_SCHOOL_LIST: DeleteSchoolList,
  UPDATE_SCHOOL_LIST: UpdateSchoolList,
};
